<template>
<!--分学银行-->
  <div class="content">
    <headers></headers>
    <div class="nav">
      <div class="auto">行业证书  >  操作指南  >  实名认证  >  证书查询 </div>
    </div>
    <div class="auto padding250">
       <p class="title">证书查询</p>
      <div class="container ">
        <p class="tip">学员您好！您必须查询所获得的证书是否具备学分认定的资格。</p>
        <div class="formWrapper">
          <Form :label-width="80" label-position="right" class="formMin" >
            <FormItem label="姓名">
              <Input  value="" placeholder="请输入姓名"/>
            </FormItem>

            <FormItem label="身份证号 ">
              <Input  value="" placeholder="请输入身份证号"/>
            </FormItem>

            <FormItem label=" ">
              <router-link to="/chaxun" style="display: none;">确认查询</router-link>
              <router-link to="/zhengshulist">确认查询</router-link>
            </FormItem>
          </Form>
        </div>


      </div>
    </div>
    <footers></footers>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
  .formWrapper{
    width: 330px;
  }

  .tip{
    font-size: 14px;
    color: #666;
    margin-bottom: 40px;
  }
  .nav{
    color: #fff;
    background-color: #2F261E;
    height: 60px;
    line-height: 60px;
    font-size: 16px;
  }
  .content{
    background-color: #f5f5f5;
    text-align: left;
    .title{
      font-size: 26px;
      color: #000;
      margin-top: 30px;
    }
    .container{
      background-color: #fff;
      padding: 50px 30px;
      margin-top: 10px;


      a{
        color: #fff;
        display: inline-block;
        width: 220px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        border-radius: 5px;
        font-size: 16px;
        background-color: #0A3C68;
      }
    }
  }
</style>
<script type="text/ecmascript-6">
  import headers from '../template/header'
  import footers from '../template/footer'

    export default {
        name: 'fenxue',
        props: {},
        data() {
            return {};
        },
        methods: {},
        created() {

        },
        components: {
          headers,
          footers

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/changeScore/zhengshuchaxun.vue